import React from 'react';
import DTConfirmation from './DTConfirmation';

export const withConfirmation = (NodeComponent) => (props) => {
  const { showConfirmation, ...otherProps } = props;

  if (showConfirmation) {
    return <DTConfirmation {...otherProps} />;
  }

  return <NodeComponent />;
};
